module.exports = "https://static.wagwalking.com/_next/static/images/cat-sitting-3-6acc4750d95e3776e2369843de7ef937.svg";